import * as React from 'react';
import "./Button.css"

export type _ButtonDetailsProps = {
    title?: string
    action?: any
    icon?: any
    style?: any
    widehide?: boolean
    className?: string
}

export type ButtonProps = {
    onClick?: any
    style?: any
    featured?:boolean
}
 
export const DetailsButton = (props: _ButtonDetailsProps) => {
    const { title,
         action,
         icon,
         style,
         widehide,
        } = props

    const onClick = () => {
        if(!!action){
            action()
        }
    }
    
    return(
        <button 
            className={`detailed-button-base`}
            onClick={onClick} 
            style={style}>
            <div className="icon-space">
                {!!icon && icon}
            </div>
            <span className={`detailed-button-title ${widehide ? "detailed-wide-hide" : ""}`}>
                {title}
            </span>
        </button>
    )
}